export enum InvoicesSortProperty {
  Status = 'status',
  InvoiceNo = 'invoiceNo',
  Date = 'issueDate',
  DueDate = 'dueDate',
  Customer = 'contact.name',
  ExcludedVat = 'netTotal',
}
